<template>
  <div class="brandDetail">
    <div class="oneCon">
      <div class="widthCon">
        <div class="left">
        <img :src="detail.brand_pic" @error="setDefaultImg" alt="" />
        <div class="textCon">
          <p class="firstLine">{{ detail.brand_name }}</p>
          <p class="secondLine">{{ detail.brand_english_name }}</p>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <p class="firstLine">{{ detail.supplier_count }}+</p>
          <p class="secondLine">入驻企业数</p>
        </div>
        <div class="content">
          <p class="firstLine">{{ detail.remain_supplier_count }}</p>
          <p class="secondLine">剩余待加入企业名额</p>
        </div>
      </div>
      </div>
    </div>
    <div class="twoCon">
      <div class="widthCon">
        <div class="left">
        <div class="firstLine">所属行业：{{ detail.first_industry_text }}</div>
        <div class="secondLine">公司名称：{{ detail.enterprise_name }}</div>
        <div class="thirdLine">{{ detail.brand_desc }}</div>
      </div>
      <div class="right">
        <div class="firstLine">
          <img src="../assets/leftIcon.png" alt="" />
          招商计划
        </div>
        <div class="secondLine">{{ detail.investment_plan }}</div>
        <div class="thirdLine">
          <div class="btn" @click="showDialog">
            联系品牌
            <img src="../assets/btnIcon.png" alt="" />
          </div>
        </div>
        <img src="../assets/back3.png" class="back3" alt="">
      </div>
      </div>
    </div>
    <div class="threeCon">
      <div class="title">已入驻生产企业</div>
      <div class="content">
        <el-row :gutter="46">
          <el-col :span="8" v-for="(item, index) in supplierList" :key="index">
            <div class="list" @click="goDetail(item)">
              <img
                :src="item.supplier_logo_img"
                @error="setDefaultImg"
                alt=""
              />
              <div class="title">{{ item.supplier_name }}</div>
              <div class="text">{{ item.copywriting_introduction }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <codeDialogVue ref="codeDialogVue" />
  </div>
</template>

<script>
import $ from "jquery";
import codeDialogVue from '@/components/codeDialog.vue';
export default {
  components: {
    codeDialogVue: codeDialogVue
  },
  data() {
    return {
      defaultImg: require("../assets/head2.png"),
      detail: {},
      brand_id: "",
      supplierList: [],
    };
  },
  mounted() {
    this.brand_id = this.$route.query.brand_id;
    this.getDetail(this.brand_id);
    this.getSupplierList();
  },
  methods: {
    goDetail(item) {
      this.$router.push({path: '/supplierDetail', query: {supplier_id: item.supplier_id}})
    },
    getDetail(brand_id) {
      $.ajax({
        type: "get",
        url: "/officialapi/brand/detail",
        async: true,
        data: {
          brand_id: brand_id,
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.detail = data.data;
            document.title = "星元计划-" + this.detail.brand_name;
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
    setDefaultImg(event) {
      event.target.src = require("../assets/head2.png");
    },
    showDialog() {
      this.$refs.codeDialogVue.init(1,this.brand_id);
    },
    getSupplierList() {
      $.ajax({
        type: "get",
        url: "/officialapi/supplier/list",
        async: true,
        data: {
          brand_id: this.brand_id,
          page: 1,
          page_size: 10000,
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.supplierList = data.data.items;
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.brandDetail {
  .oneCon {
    height: 214px;
    width: 100%;
    background: linear-gradient(180deg, #dae6ff 0%, rgba(228, 237, 255, 0) 99%);
    box-sizing: border-box;
    .widthCon{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      height: 100%;
    }
    .left {
      display: flex;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        margin-right: 26px;
      }
      .textCon {
        .firstLine {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: bold;
          line-height: 22px;
          letter-spacing: normal;
          color: #222222;
          margin-bottom: 20px;
        }
        .secondLine {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          line-height: 22px;
          letter-spacing: normal;
          color: #666666;
        }
      }
    }
    .right {
      flex: 0 0 540px;
      .content {
        display: inline-block;
        width: 234px;
        height: 130px;
        border-radius: 10px;
        background: #ffffff;
        margin-left: 36px;
        text-align: center;
        .firstLine {
          font-family: Source Han Sans;
          font-size: 40px;
          font-weight: bold;
          line-height: 34px;
          text-align: center;
          letter-spacing: normal;
          color: #4a90e2;
          margin-bottom: 10px;
          margin-top: 25px;
        }
        .secondLine {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          line-height: 34px;
          letter-spacing: normal;
          color: #666666;
        }
      }
    }
  }
  .twoCon {
    padding: 35px 0px 40px 0px;
    .widthCon{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .left {
      margin-right: 60px;
      flex: 1;
      .firstLine {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 34px;
        letter-spacing: normal;
        color: #222222;
      }
      .secondLine {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 34px;
        letter-spacing: normal;
        color: #222222;
      }
      .thirdLine {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: normal;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #222222;
        text-indent: 2em;
text-align: justify;
        margin-top: 22px;
        text-align: justify;
      }
    }
    .right {
      flex: 0 0 557px;
      border-radius: 10px;
      background: #eff9ff;
      padding: 33px 41px 35px 55px;
      position: relative;
      overflow: hidden;
      .back3{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        max-height: 100%;
      }
      .firstLine {
        position: relative;
        z-index: 999;
        img {
          width: 47.5px;
          height: 47.5px;
          position: absolute;
          left: -22px;
          top: -8px;
        }
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 34px;
        letter-spacing: normal;
        color: #222222;
      }
      .secondLine {
        position: relative;
        z-index: 999;
        margin-top: 17px;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: normal;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #222222;
        text-indent: 2em;
text-align: justify;
        text-align: justify;
        min-height: 170px;
      }
      .thirdLine {
        position: relative;
        z-index: 999;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        .btn {
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 500;
          line-height: 34px;
          text-align: right;
          letter-spacing: 0.2em;
          color: #ffffff;
          width: 256px;
          height: 50px;
          line-height: 50px;
          border-radius: 288px;
          background: #4a90e2;
          box-sizing: border-box;
          border: 1px solid #4a90e2;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 18px;
            height: 18px;
            margin-left: 12px;
          }
        }
      }
    }
  }
  .threeCon {
    padding: 48px 0px 37px 0px;
    background: #f8fafc;
    .title {
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      letter-spacing: normal;
      color: #222222;
      margin-bottom: 43px;
      text-align: center;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      .list {
        height: 100%;
        text-align: center;
        border-radius: 10px;
        background: #ffffff;
        padding: 35px 24px 26px 24px;
        margin-bottom: 43px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          margin-bottom: 14px;
        }
        .title {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: bold;
          line-height: 34px;
          letter-spacing: normal;
          color: #222222;
          margin-bottom: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .text {
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 30px;
          letter-spacing: normal;
          color: #222222;
          text-indent: 2em;
text-align: justify;
          height: 90px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
}
</style>